import actionsForm from '@/shared/mixins/actionsForm'
import Data from '@/shared/models/pci/tecserviceanalysisnamodel'
import Form from './tecanalysisna-form'
import ServiceAnalysisTecRepository from '@/shared/http/repositories/pci/tecserviceanalysis'
import ServiceAnalysisTecNaRepository from '@/shared/http/repositories/pci/tecserviceanalysisna'

import Tables from '@/components/forms/Tables.vue'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'TecAnalysisNa',
  mixins: [actionsForm],
  components: {
    Tables
  },
  data () {
    return {
      data: Data,
      form: Form,
      pci: [],
      objList: []
    }
  },
  methods: {
    onLoad () {
    },
    onHide () {
      this.$refs['tecAnalysisNaModal'].hide()
    },
    onValidate () {
      if (this.objList.some(s => s.status === 1 && s.servicoAnaliseTecID === this.form.servicoAnaliseTecID.value)) {
        toast.warning(this.$lang.PCI.ATNA.AlreadyExists)
        return
      }
      this.pci.forEach(p => {
        this.form.obraID.value = p.obraId
        this.onSave()
      })
    },
    onCreate () {
      loading.push()
      ServiceAnalysisTecNaRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.objList.unshift(response.data.data)
            this.$emit('update')
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onDelete (obj) {
      loading.push()
      obj.status = 0
      ServiceAnalysisTecNaRepository.Update(obj)
        .then(response => {
          if (response.data.code > 0) {
            this.load()
            this.$emit('update')
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    load (pci) {
      return ServiceAnalysisTecRepository.GetAllByPci(this.pci[0].pciId)
        .then(response => {
          if (response.data.code > 0) {
            this.form.servicoAnaliseTecID.options = response.data.data
          }
        })
    },
    show (pci) {
      this.pci = pci

      this.load()
        .then(() => {
          const workIDs = pci.map(p => p.obraId)
          ServiceAnalysisTecNaRepository.GetAllByWork({params: {obraIDs: workIDs}, paramsSerializer: {indexes: null}})
            .then(response => {
              if (response.data.code > 0) {
                this.objList = response.data.data
              }
            })
        })
        .then(() => this.$refs['tecAnalysisNaModal'].show())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/tecanalysisna/tecanalysisna.js